import React from 'react';
import memoizeOne from 'memoize-one';
import FilterSearch from '@jira/platform__filter-search-with-analytics/src/FilterSearchWithAnalytics.tsx';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import type { FilterViewProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import ProjectPicker from '@atlassian/jira-project-picker/src/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import UserPicker from '@atlassian/jira-user-picker/src/index.tsx';
import type { Filter as FilterType } from '../../../model/index.tsx';
import {
	getFilter,
	getSelectedProject,
	getSearchText,
	getSelectedUser,
	getLoggedInUserAccountId,
} from '../../../state/selectors/query/index.tsx';
import type { State } from '../../../state/types.tsx';
import type { FilterSearchProps, ProjectSearchProps, UserSearchProps } from './types.tsx';
import Filter from './view.tsx';

const FilterSearchWithAnalytics = withFireUiAnalytics({
	onChange: 'filterSearch',
})(FilterSearch);
const ProjectTypePickerWithAnalytics = withFireUiAnalytics({
	onChange: 'projectSearch',
})(ProjectPicker);
const UserPickerWithAnalytics = withFireUiAnalytics({ onChange: 'user' })(UserPicker);

const renderFilterSearch = (state: State) => (props: FilterSearchProps) => (
	<FilterSearchWithAnalytics {...props} value={getSearchText(state)} />
);

const renderProjectPicker = (state: State) => (props: ProjectSearchProps) => (
	/* @ts-expect-error - Type '{ selectedProject: Project | undefined; inputId: string; label?: string | undefined; width?: string | undefined; isDisabled?: boolean | undefined; placeholder?: string | undefined; ... 6 more ...; onChange: (arg1: Project, arg2: UIAnalyticsEvent) => void; }' is not assignable to type 'Omit<{ onChange: (arg1: Project | undefined, args_1: UIAnalyticsEvent) => void; placeholder?: string | undefined; selectedProject: Project | undefined; ... 10 more ...; forwardedRef?: Ref<...> | undefined; }, keyof WithAnalyticsEventsProps>'. */
	<ProjectTypePickerWithAnalytics
		{...props}
		selectedProject={getSelectedProject(state)}
		inputId="board-filters-project-picker-select"
		width="100%"
	/>
);

const renderUserPicker = (state: State) => (props: UserSearchProps) => {
	return (
		<UserPickerWithAnalytics
			{...props}
			selectedUser={getSelectedUser(state)}
			suggestedAccountId={getLoggedInUserAccountId(state) ?? undefined}
			isCompact
			shouldFitContainer
		/>
	);
};

const mapStateToPropsFactory = () => {
	const renderFilterSearchFactory = memoizeOne(renderFilterSearch);
	const renderProjectPickerFactory = memoizeOne(renderProjectPicker);
	const renderUserPickerFactory = memoizeOne(renderUserPicker);
	return (state: State, ownProps: FilterViewProps<FilterType>) => ({
		value: getFilter(state),
		onChange: ownProps.onFilter,
		renderFilterSearch: renderFilterSearchFactory(state),
		renderProjectPicker: renderProjectPickerFactory(state),
		renderUserPicker: renderUserPickerFactory(state),
	});
};

export default connect(mapStateToPropsFactory, {})(Filter);
